import React, { Component, PureComponent } from 'react';
import cloneDeep from 'lodash/cloneDeep';
import isEqual from 'lodash/isEqual';
import { components } from 'react-select'

class MultiValueContainers extends Component<any, any>{
  shouldComponentUpdate(nextProps, nextState) {
    if (nextProps && this.props) {
      if (nextProps.children && this.props.children && nextProps.children.length !== this.props.children) {
        return true
      }
      if (nextProps.data && this.props.data && !isEqual(nextProps.data, this.props.data)) {
        return true
      }
      if (nextProps.innerProps && this.props.innerProps && !isEqual(nextProps.innerProps, this.props.innerProps)) {
        return true
      }
      if (nextProps.selectProps && this.props.selectProps && !isEqual(nextProps.selectProps, this.props.selectProps)) {
        return true
      }
    }
    return false;
  }

  render() {
    const { children,selectProps } = this.props;
    const newChildren = cloneDeep(children);
    const nbValues = selectProps?.value?.length;
    newChildren[0] = `${nbValues} ${selectProps?.selectedLabel || 'items selected'}`;

    if (nbValues < 2) {
      return (
        <div className="multi-value-wrapper">
          <components.MultiValueContainer {...this.props}>
            {children}
          </components.MultiValueContainer>
        </div>
      );
    }
    return (
      <div className="multi-value-wrapper">
        <components.MultiValueContainer {...this.props}>
          {<>
            <span className="multi-value-count">{newChildren[0]}</span>
            <span className="multi-value-list">{children}</span>
          </>}
        </components.MultiValueContainer>
      </div>
    );
  }
}

export default MultiValueContainers